import { render } from "./ObjectiveSectionResult.vue?vue&type=template&id=48ba487b&scoped=true"
import script from "./ObjectiveSectionResult.vue?vue&type=script&lang=js"
export * from "./ObjectiveSectionResult.vue?vue&type=script&lang=js"

import "./ObjectiveSectionResult.vue?vue&type=style&index=0&id=48ba487b&lang=scss&scoped=true"
import "./ObjectiveSectionResult.vue?vue&type=style&index=1&id=48ba487b&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ba487b"]])

export default __exports__